<template>
    <Card :title="$t('access.doors.list')" containerClass="mb-5">
      <template #cardToolbar>
        <div class="d-flex justify-content-end align-items-center">
          <div>
            <Button type="new" v-if="true && $can(abilities.CAN_CREATE_DOOR)" btn-class="me-3 btn-sm" btn-text="access.doors.create"  @click="openCreateModal" ></Button>
            <Button type="new" v-if="true && $can(abilities.CAN_IMPORT_DOOR) " btn-class="me-3 btn-sm" btn-text="access.doors.import"  @click="openImportExportModal" ></Button>
          </div>
        </div>
      </template>
      <template #cardBody>
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_doors" style="margin-top: 13px !important; cursor:pointer">
          <thead style="background-color: #F2F3F4;">
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                <th class="px-4 ">{{$t("access.doors.name")}}</th>
                <th class="px-4 ">{{$t("access.doors.perimeter")}}</th>
                <th>{{$t("actions")}}</th>
            </tr> 
          </thead>
        </table>
      </template>
    </Card>

    <UpdateDoors :form="formEdit" @load="reloadDatatable" id="updateDoorsModal" :isEdit="true" />
    <CreateDoors @load="reloadDatatable" id="createDoorsModal" />
    <ImportExportDoors id="importExportDoorsModal" @load="reloadDatatable" />
</template>

<script setup>
    import {ref,onMounted,watch,nextTick} from "vue";
    import {BASE_URL} from "@/services/api";
    import {useStore} from "vuex";
    import Ls from "@/services/ls";
    import { useI18n } from 'vue-i18n'
    import { useLocales } from '@/composables/locales';
    import Button from "@/components/Button.vue";
    import CreateDoors from "@/Modules/Access/components/Modals/Doors/CreateOrUpdateDoors.vue";
    import UpdateDoors from "@/Modules/Access/components/Modals/Doors/CreateOrUpdateDoors.vue";
    import Card from "@/Modules/CRM/components/Card";
    import {Theme} from "@/composables/theming";
    import {useSwal} from "@/composables/useSwal";
    import abilities from "@/composables/abilities";
    import {useHasAbility} from "@/composables/hasAbility";
    import ImportExportDoors from "@/Modules/Access/components/Modals/Doors/ImportExportModal.vue"

    const table = ref(null)
    const formEdit = ref({
        id: '',
        name: '',
        perimeter_id: '',
        device: ''
    })
    const store = useStore()

    const { t } = useI18n({ useScope: 'global' })
    const {locale, datatableLocaleUrl} = useLocales()
    const {showSwal} = useSwal()
    const { can } = useHasAbility()

    function openCreateModal(){
        $('#createDoorsModal').modal('toggle')
    }

    function fetchDatas() {
        const AUTH_TOKEN = Ls.get('auth.token')

        table.value = $("#kt_datatable_doors").DataTable({
            destroy : true,
            responsive: !0,
            searchDelay: 500,
            processing: !0,
            serverSide: !0,
            pageLength:Ls.get('pageLength') ?? 5,
            lengthMenu: [5, 10, 25, 50, 75, 100 ],
            order: [[ 0, 'desc']],
            ajax: {
            url: BASE_URL+"/get/doors/datatables",
            type: "GET",
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
                request.setRequestHeader("Company", Ls.get('current.company'));
                },
            data:  function ( d ) {

            }
            },
            columns: [{ data: "name" }, { data: "perimeter_name" }, { data: "Actions", responsivePriority: -1 }],

            columnDefs: [
            {
                targets: -3,
                order: "desc",
                render: function (t, a, e, l) {
                return '<span class="nameRow'+ l.row +'">' + t + "</span>";
                },
            },
            {
                targets: -2,
                order: "desc",
                render: function (t, a, e, l) {
                return '<span class="perimeterRow'+ l.row +'">' + t + "</span>";
                },
            },
            {
                width: "16%",
                targets: -1,
                "className": "dt-center",
                title: "Actions",
                orderable: !1,
                render: (t, a, e, l) => {
                let render = '';
                if(true) render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-name="${e.name}" data-perimeter="${e.perimeter_id}" data-device="${e.device}" class="btn btn-sm btn-clean btn-icon edit_btn" title="${i18n.global.t('button.edit')}"><i data-row="${l.row}" data-id="${e.id}" data-name="${e.name}" data-perimeter="${e.perimeter_id}" data-device="${e.device}" class="fas fa-edit fs-2"  style="color: ${Theme.gray}" style="color: ${Theme.gray}"></i></a>`;
                if(true) render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon delete_btn" title="${i18n.global.t('button.delete')}"><i data-row="${l.row}" data-id="${e.id}" class="fas fa-trash fs-2" style="color: ${Theme.gray}" style="color: ${Theme.gray}"></i></a>`;
                return render;
                },
            },

            ],
            language: {
            url:  datatableLocaleUrl.value
            }
        });

        $(document).on("click", "#kt_datatable_doors .edit_btn", (e) => {
            formEdit.value.id = e.target.getAttribute('data-id')
            formEdit.value.name = e.target.getAttribute('data-name')
            formEdit.value.perimeter_id = e.target.getAttribute('data-perimeter'),
            formEdit.value.device = e.target.getAttribute('data-device')

            $('#updateDoorsModal').modal('toggle')
        });
    }

    function reloadDatatable(){
        table.value.ajax.reload()
    }

    $(document).on("click", "#kt_datatable_doors .delete_btn", (e) => {
        deleteDoors(e.target.getAttribute('data-id'))
    });


    async function deleteDoors(id){
        showSwal(
            t('access.doors.swal_delete_title'),
            t('access.doors.swal_delete_text')
        ).then( async (result) => {
            if (result.value) {
            try {
                await store.dispatch('doors/deleteDoors', id)
                reloadDatatable()
                window.toastr.success(t('notification.doors_deleted'))
            } catch (e) {
            }
            }
        });
    }

    function openImportExportModal() {
        $('#importExportDoorsModal').modal('toggle')
    }

    watch(() => locale.value, () => {
        nextTick(()=> fetchDatas())
    })

    onMounted(() => {
        fetchDatas()
    })
</script>